<template>
  <main class="main-tag">
    <div class="login-page login-page-default row" id="login-page">

      <div class="col-md-4 offset-md-4 col-sm-8 offset-sm-2 text-left pt-5">
        <h4 class="welcome-heading-text q-mb-sm ptl">
          {{ t('login.wait_oidc_login') }}
        </h4>

      </div>
    </div>
  </main>
</template>

<script>
import { computed, onMounted } from 'vue';
import store from '../store/index.js';
import { useRouter } from 'vue-router'
import axios from 'axios';
import axiosUrl from '../services/axios.service';
import { useI18n } from 'vue-i18n';

const API_URL = axiosUrl.getAxiosUrl();



export default {
  name: 'OidcAuth',
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const isLoggedIn = computed({
      get: () => store.state.auth.isLoggedIn,
    });

    if (isLoggedIn.value == true) {
      router.push({
        name: 'SearchGrants',
      });
    }
    const urlParams = new URLSearchParams(window.location.search);

    const hasComeFromNewsletter = computed({
      get: () => store.state.user.hasComeFromNewsletter,
    });

    const newsletterId = computed({
      get: () => store.state.user.newsLetterId,
    });

    const hasUserClickedOnNews = computed({
      get: () => store.state.auth.hasClickedNewsOnLoginPage,
    });
    onMounted(async () => {
      const returnUrl = urlParams.get('redir');

      await axios
        .post(API_URL + '/users/authenticate-oidc', {
          username: urlParams.get('username'),
          code: urlParams.get('code'),
          sid: urlParams.get('sid')
        })
        .then(response => {
          if (response.data.token) {
            var token = JSON.stringify(response.data);
            localStorage.setItem('user', token);
            store.state.auth.isLoggedIn = true;
            store.state.auth.user = response.data;

            var cookies = document.cookie.split("; ");
            for (var c = 0; c < cookies.length; c++) {
              var d = window.location.hostname.split(".");
              while (d.length > 0) {
                var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
                var p = location.pathname.split('/');
                document.cookie = cookieBase + '/';
                while (p.length > 0) {
                  document.cookie = cookieBase + p.join('/');
                  p.pop();
                }
                d.shift();
              }
            }
            if (location.hostname.split('.').reverse()[1] != null) {
              document.cookie = `${process.env.VUE_APP_ENV}contentAuth=${response.data.token}; domain=${location.hostname.split('.').reverse()[1]}.${location.hostname.split('.').reverse()[0]}; path=/`;
            }
            else {
              document.cookie = `${process.env.VUE_APP_ENV}contentAuth=${response.data.token}; domain=localhost`;
            }

            if (returnUrl != null && returnUrl != 'undefined' && returnUrl != '' && returnUrl != '/') {
              location.href = returnUrl;
            } else if ((returnUrl == null || returnUrl == 'undefined' || returnUrl == '' || returnUrl == '/') && !token.hasContent && token.hasSas) {
              location.href = process.env.VUE_APP_SAS_BASE_URL;
            } else if ((returnUrl == null || returnUrl == 'undefined' || returnUrl == '' || returnUrl == '/') && !token.hasSas && !token.hasContent) {
              location.href = '/login';
            }

            router.replace({ path: '/search-grants' });
            return;
            // if (!response.data.hasCompletedProfileSetup) {
            //   router.push({
            //     name: 'UserProfile',
            //     params: { tab: 'newsletter' },
            //   });
            //   store.commit('user/updateHasBeenRedirectedToProfile', true);
            //   store.commit('user/setHasConfirmedLeave', false);
            // } else if (hasComeFromNewsletter.value) {
            //   router.push({
            //     name: 'NewsDetails',
            //     params: { newsId: newsletterId.value },
            //   });

            //   store.commit('user/setHasComeFromNewsletter', true);
            // } else if (hasUserClickedOnNews.value) {
            //   router.push({
            //     name: 'News',
            //   });
            // } else  {
            //   router.push({
            //     name: 'SearchGrants',
            //   });
            // }
            // if (Number.parseInt(token.custid) != 2) // if customer is not Vind, check language
            //   authService.getAppropriateLanguageBasedBaseUrl(token.id);
          }
        })
        .catch(() => {
          router.replace({ path: '/geen-account' });
          return;
        });
    });

    return {
      t,
      router,
      isLoggedIn,
      hasComeFromNewsletter,
      newsletterId,
      hasUserClickedOnNews
    };
  },
};
</script>
<style>
.ptl {
  padding-top: 100px;
}
</style>